import { SuSyApi } from './susyApi';

export const validatePasswordPolicy = async (
    email: string,
    password: string
): Promise<void> => {
    const { data } = await SuSyApi.post(`/user/validatePasswordPolicy`, {
        email,
        password,
    });

    return data;
};
